import React, { useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import {UsePermissions} from "../../../hooks/usePermissions";
import './AsociadoDeduccion.scss';
import PropTypes from "prop-types";

export const TablaAsociadoDeduccion = ({dataDeducciones, obtenerParametros, nuevoUsuario}) => {

    const toast = useRef(null);
    const [permisos] = UsePermissions();
    const [expandedRows, setExpandedRows] = useState(null);

    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <h1>Datos Deducciones Asociados</h1>
            </div>
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={nuevoUsuario}
                >
                    <i className="fa fa-user"/>
                </button>
                {/*<button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                >
                    <i className="fa fa-search"/>
                </button>*/}
            </div>
        </div>
    );

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">
                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => obtenerParametros(rowData) }
                >
                    <i className="fa fa-user-edit"/>
                </button>
            </div>
        );
    }

    const rowExpansionTemplate = (data) => {

        return (
            <div className="orders-subtable">
                <DataTable showGridlines value={data.deduccionesAsociado} responsiveLayout="scroll">
                    <Column header="Gestionar" style={{fontSize: ".8em"}} style={{width:'500px'}} body={actionTemplate}></Column>
                    <Column field="deduccion" header="Deduccion" style={{width:'500px'}} filter sortable></Column>
                    <Column field="tercero" header="Tercero" style={{width:'40%'}} filter sortable></Column>
                </DataTable>
            </div>
        );
    }

    return(
        <div className="datatable-rowexpansion-demo">
            <Toast ref={toast} />

            <div className="card">
                <DataTable
                    resizableColumns
                    columnResizeMode="expand"
                    header={header}
                    size="small"
                    showGridlines
                    value={dataDeducciones}
                    scrollable
                    scrollHeight="400px"
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                    responsiveLayout="scroll">
                        <Column expander style={{ width: '40%' }} />
                        <Column style={{width:'60%'}} field="nombre" filter header="Nombre Asociado" sortable />
                </DataTable>
            </div>
        </div>
    )
};

TablaAsociadoDeduccion.prototype = {
    obtenerParametros: PropTypes.func,
    nuevoUsuario: PropTypes.func
}

TablaAsociadoDeduccion.defaultProps = {
    reload: false
}
